import Personalizer from 'personalizer';
var measurementSystem = Personalizer.measurementSystem;

// Note: weight, height, and age min/maxes are based on BIC requirements
var BiometricLimits = {
    minWeight: measurementSystem === 'metric' ? 1 : 2, // kg or lbs
    maxWeight: measurementSystem === 'metric' ? 453 : 999,

    //limits for kg when measurementSystem = statute_uk and weight unit is metric
    minKgWeight: 1,
    maxKgWeight: 453,

    //stones and lbs
    minStWeight: 0,
    maxStWeight: 71,
    minLbsWeight: 0,
    maxLbsWeight: 13.9,
    //max value for stones is 71 st 5 lbs
    maxStLbsWeight: 5,

    minBodyFat: 1,
    defaultBodyFat: 20,
    maxBodyFat: 50,

    minMuscleMassKg: 1.7,
    defaultMuscleMassKg: 11,
    maxMuscleMassKg: 90.9,

    minMuscleMassLbs: 3.7,
    defaultMuscleMassLbs: 25,
    maxMuscleMassLbs: 200,

    minHeight: measurementSystem === 'metric' ? 92 : 36, // cm or inches
    maxHeight: measurementSystem === 'metric' ? 254 : 100,

    minAge: 16, // Number of times around the Sun
    maxAge: 120,
    minBirthYear: 1900,

    minVo2max: 1, // ml/kg/min
    maxVo2max: 100,

    minCyclingTrainingSpeed: 0,
    maxCyclingTrainingSpeed: measurementSystem === 'metric' ? 160 : 100, // kph or mph

    minCyclingAvgPower: 0,
    maxCyclingAvgPower: 5000, // watts

    MAX_HEART_RATE_MIN: 35, // bpm
    MAX_HEART_RATE_MAX: 250,
    MAX_HEART_RATE_DEFAULT: 185,
    MIN_RESTING_HEART_RATE: 30,
    MIN_LACTATE_THRESHOLD_HEART_RATE: 60,

    HR_ZONE_MAX: 200,
    HR_ZONE_MIN: 30
};

export default BiometricLimits;
